import { STORE_OLD } from "@/shared/store";
import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { storeRFC_QRTK } from "./qrtk";
import { appVersionApi } from "./appVersion/appVersionApi";
import storeSlicesRf from "./redux/store-slices-rf";

const { middleware, reducer } = STORE_OLD;
export const store = configureStore({
  reducer: {
    ...reducer,
    ...storeRFC_QRTK.reducer,
    ...storeSlicesRf.reducer,
    [appVersionApi.reducerPath]: appVersionApi.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat([
      ...storeRFC_QRTK.middleware,
      appVersionApi.middleware,
      ...middleware
    ])
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
